import { ManagementState } from './types';

const defaultRequest = () => ({
  loading: false,
  loaded: false,
  error: false,
});

const INITIAL_STATE: ManagementState = {
  management: {
    management_summary: {
      total_favorites: 0,
      total_managed: 0,
      total_finished: {
        winner: 0,
        partial_winner: 0,
        lost: 0,
        declined: 0,
        revoked: 0,
        failed: 0,
        cancelled: 0,
      },
      total_tasks: {
        late: 0,
        today: 0,
        future: 0,
        finished: 0,
      },
      total_progress: {
        read: 0,
        unread: 0,
      },
    },
    bidding_summary: {},
    calendar_events: [],
    managed: [],
    managed_total_entries: 0,
    finished: [],
    finished_total_entries: 0,
    tasks: [],
    tasks_total_entries: 0,
    bidding_tasks: [],
    bidding_tasks_total_entries: 0,
    timeline_tasks: [],
    timeline_progress: [],
    modal_task: null,
    notification_progress: [],
    notification_progress_total_entries: 0,
    progress: [],
    selected_feature: 'favorites',
    filtered_by: 'client',
    ordered_by: 'modified',
    order_direction: 'desc',
    overview: null,
    overview_last_updated: Date.now(),
    overview_bidding_id: null,
    members: null,
  },
  management_attachments: {},
  management_preferences: {
    id: 0,
    user_id: 0,
    client_id: 0,
    email_notification: false,
    whatsapp_notification: false,
    push_notification: false,
    clarification_notification: false,
    notice_notification: false,
    impugnment_notification: false,
    appeal_notification: false,
    status_notification: false,
    result_notification: false,
  },
  request: {
    management_summary: defaultRequest(),
    bidding_summary: defaultRequest(),
    calendar_events: defaultRequest(),
    managed: defaultRequest(),
    finished: defaultRequest(),
    get_tasks: defaultRequest(),
    get_bidding_timeline: defaultRequest(),
    get_task_by_id: defaultRequest(),
    create_tasks: defaultRequest(),
    update_tasks: defaultRequest(),
    delete_task: defaultRequest(),
    create_task_comment: defaultRequest(),
    delete_task_comment: defaultRequest(),
    create_progress_comment: defaultRequest(),
    create_task_attachment: defaultRequest(),
    delete_task_attachment: defaultRequest(),
    create_progress_attachment: defaultRequest(),
    get_notification_progress: defaultRequest(),
    update_notification_progress: defaultRequest(),
    create_progress: defaultRequest(),
    update_progress: defaultRequest(),
    delete_progress: defaultRequest(),
    finish_managed: defaultRequest(),
    finish_managed_batch: defaultRequest(),
    reactivate_managed: defaultRequest(),
    update_tasks_status_batch: defaultRequest(),
    mark_read_progress_batch: defaultRequest(),
    mark_unread_progress_batch: defaultRequest(),
    get_bidding_documents_attachments: defaultRequest(),
    get_management_preferences: defaultRequest(),
    update_management_preferences: defaultRequest(),
    get_bidding_overview: defaultRequest(),
    get_management_members: defaultRequest(),
  },

  request_management_attachments: {
    get_management_attachments: defaultRequest(),
    create_management_attachements: {},
    delete_management_attachements: defaultRequest(),
  },
};

export default INITIAL_STATE;
